const maskPart = (part) => `${part.slice(0, 1)}***`;
export const maskEmail = (email) => {
    const [mailbox = "", domain = ""] = email.trim().split("@");
    const extensionStart = domain.lastIndexOf(".");
    if (!mailbox || extensionStart <= 0) {
        return "***";
    }
    return `${maskPart(mailbox)}@${maskPart(domain.slice(0, extensionStart))}${domain.slice(extensionStart)}`;
};
